import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { promotionKeys, type RedemptionFilters } from "./query-keys";

/** GET /v1/promotion-redemptions — redemption ledger (read-only). */
export function useRedemptionLedger(filters?: RedemptionFilters) {
  return useQuery({
    queryKey: promotionKeys.redemptions(filters),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/promotion-redemptions", {
        params: { query: filters ?? {} },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
